import {
  Component,
  DestroyRef,
  OnInit,
  PLATFORM_ID,
  inject,
  signal,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [],
  template: `
    <nav [class.scrolled]="isScrolled()">
      <div class="nav-container">
        <a href="#hero" class="nav-brand">
          K<span class="nav-brand-accent">ΛI</span>ZENIC
        </a>

        <div class="nav-right">
          <ul class="nav-links" [class.active]="isMobileMenuOpen()">
            <li>
              <a
                href="#"
                class="nav-cta-button secondary"
                (click)="handleLogin($event)"
              >
                Login
              </a>
            </li>
            <li>
              <a
                href="#"
                class="nav-cta-button primary"
                (click)="handleSignup($event)"
              >
                Get Started Free
              </a>
            </li>
          </ul>

          <button
            class="nav-menu-toggle"
            (click)="toggleMobileMenu()"
            [attr.aria-expanded]="isMobileMenuOpen()"
            aria-label="Toggle menu"
          >
            <span class="hamburger-icon" [class.open]="isMobileMenuOpen()">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </div>
    </nav>
  `,
})
export class NavigationComponent implements OnInit {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly authService = inject(AuthService);
  private readonly destroyRef = inject(DestroyRef);

  readonly isScrolled = signal(false);
  readonly isMobileMenuOpen = signal(false);

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const handler = () => this.isScrolled.set(window.scrollY > 50);
      window.addEventListener('scroll', handler, { passive: true });
      this.destroyRef.onDestroy(() =>
        window.removeEventListener('scroll', handler),
      );
    }
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen.update((v) => !v);
  }

  async handleLogin(event: Event): Promise<void> {
    event.preventDefault();
    try {
      await this.authService.login();
    } catch {
      // Auth redirect failed — no user-visible action needed here
    }
  }

  async handleSignup(event: Event): Promise<void> {
    event.preventDefault();
    try {
      await this.authService.signup();
    } catch {
      // Auth redirect failed — no user-visible action needed here
    }
  }
}
